import React, { Component } from 'react';
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import Cookies from "js-cookie";
import ellipsis from '../resources/images/png/menu.png'
import { cities, getCity } from "../services/cities";
import { clearHubDataFromStorage } from "../services/hubs";

const base = 'header';

@inject('CheckInStore', 'HeaderStore', 'UserStore')
@observer
class Header extends Component {
  logout = () => {
    Cookies.remove('token');
    clearHubDataFromStorage();
    window.location.replace("/");
  };
  
  render() {
    const { CheckInStore, HeaderStore } = this.props;
    const header = HeaderStore.header;
    const city = cities[getCity()];
    const hubName = localStorage.getItem('hub_name');
    return(
      <div className={`${base} bg--grey`}>
        <div className={`${base}__container container display--flex`}>
          <div className={`${base}__title`}>
            {header === 'check-in'
              ? (CheckInStore.currentPage === 1 || CheckInStore.isSubmitted)
                  ? <Link to="/" className="link--no-underline"><h3 className="text--white fs--medium" onClick={ CheckInStore.back }>Back to overview</h3></Link>
                  : <h3 className="text--white fs--medium cursor-pointer" onClick={ CheckInStore.back }>Back</h3>
              : header === 'update'
                ? CheckInStore.currentPage === 2
                  ? <Link to="/" className="link--no-underline"><h3 className="text--white fs--medium" onClick={ CheckInStore.back }>Back to overview</h3></Link>
                  : <h3 className="text--white fs--medium cursor-pointer" onClick={ CheckInStore.back }>Back</h3>
                : <h3 className="text--white fs--medium">Rider Check-In</h3>
            }
          </div>
          <div className={`${base}__hub-details`}>
              { city }{ localStorage.getItem('hub_name') && ` - ${hubName}` }
          </div>
          <div className={`${base}__dropdown text--white center--vertical`}>
            <img className='margin--left' src={ellipsis} style={{width: "22px"}} alt="ellipsis icon"></img>
            <div className="dropdown-content">
              <a className="cursor-pointer" onClick={this.logout}>Sign out</a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Header


// WEBPACK FOOTER //
// ./src/components/Header.js